import { useContext } from "react";
import { WidgetEditorContext } from "@nexus/widget-sdk";
import { prefersReducedMotion } from "./useAnimatedNumber";
// The motion recipes (nx-rise, nx-pop…) travel with the hook that turns them on.
import "./motion.css";

/**
 * Whether the widget may animate its content: in consultation, preview and
 * presentation, never while the dashboard is being composed (the editor canvas
 * re-renders widgets on every change, and moving figures get in the way of
 * arranging them). Reduced motion is honoured separately, by the CSS media
 * query and `useAnimatedNumber`.
 */
export function useWidgetMotion(): boolean {
  return useContext(WidgetEditorContext) === null;
}

/** `className` when motion is allowed, otherwise nothing. */
export function motionClass(motion: boolean, className: string): string {
  return motion ? className : "";
}

/**
 * Whether a chart draws itself in (ECharts entry animation): only when its author
 * turned "Animate chart" on (`config.animateChart: true`, off by default — a wall
 * screen shows its figures at once), outside the editor and without reduced motion.
 * Updates after the first draw follow the same answer.
 */
export function useChartAnimation(config: { animateChart?: unknown }): boolean {
  const motion = useWidgetMotion();
  return motion && config.animateChart === true && !prefersReducedMotion();
}
